<script>
  import { Link, link, navigate } from "svelte-navigator";
  import { doLogout } from "../helpers/login";
  import { user } from "../stores";

  let isSigningOut = false;

  const handleLogout = () => {
    isSigningOut = true;
    setTimeout(() => {
      doLogout().then(() => {
        isSigningOut = false;
        toggleNav();
      });
    }, 450);
  };

  const toggleNav = () => {
    var nav = document.getElementById("navbarMainMenu");
    var className = nav.getAttribute("class");
    if (className == "navbar-menu") {
      nav.className = "navbar-menu is-active";
    } else {
      nav.className = "navbar-menu";
    }
  };
</script>

<nav class="navbar is-light" role="navigation" aria-label="main navigation">
  <div class="navbar-brand">
    <a class="navbar-item has-text-weight-bold" href="/">
      <img
        src="/apple-touch-icon.png"
        height="28"
        alt="Class Timer logo - a stopwatch emoji"
      />
      Class Timer
    </a>

    <!-- svelte-ignore a11y-missing-attribute -->
    <button
      role="button"
      class="navbar-burger"
      aria-label="menu"
      aria-expanded="false"
      data-target="navbarBasicExample"
      on:click={toggleNav}
    >
      <span aria-hidden="true" />
      <span aria-hidden="true" />
      <span aria-hidden="true" />
    </button>
  </div>

  <div id="navbarMainMenu" class="navbar-menu">
    <div class="navbar-start">
      {#if $user.loggedIn}
        <div class="navbar-item">
          <div class="buttons">
            <a
              href="/teach"
              class="button is-light"
              use:link
              on:click={toggleNav}
            >
              My class
            </a>
            <a
              href="profile"
              class="button is-light"
              use:link
              on:click={toggleNav}>Profile</a
            >
          </div>
        </div>
      {/if}
    </div>

    <div class="navbar-end">
      {#if !$user.loggedIn}
        <div class="navbar-item">Leaders:</div>
        <div class="navbar-item">
          <div class="buttons">
            <Link to="login" class="button is-primary">
              <strong>Sign up</strong>
            </Link>
            <Link to="login" class="button is-light">Log in</Link>
          </div>
        </div>
      {:else}
        <div class="navbar-item">
          <div class="buttons">
            <button
              class="button is-light"
              on:click={handleLogout}
              class:loading={isSigningOut}
            >
              Log out
            </button>
          </div>
        </div>
      {/if}
    </div>
  </div>
</nav>
